import {
    MORE_CREATE_PRODUCT_TEMPLATE,
    MORE_CREATE_PRODUCT_TEMPLATE_SUCCESS,
    MORE_CREATE_PRODUCT_TEMPLATE_FAILURE,
    MORE_RESET_CREATE_TEMPLATE,
} from 'src/pages/more/pages/templates/redux/action/actionTypes.js';

const initialState = {
    templateDetails: {
        loading: false,
        statusCode: 0,
        statusMessage: '',
    },
    createTemplate: {
        loading: false,
        statusCode: 0,
        statusMessage: '',
    },
    updateTemplate: {
        loading: false,
        statusCode: 0,
        statusMessage: '',
    },
    orderTemplate: {
        loading: false,
        statusCode: 0,
        statusMessage: '',
    },
};

const CreateTemplateReducer = (state = initialState, action) => {
    switch (action.type) {
        case MORE_CREATE_PRODUCT_TEMPLATE:
            return {
                ...state,
                createTemplate: {
                    loading: true,
                    statusCode: 0,
                    statusMessage: '',
                },
            };
        case MORE_CREATE_PRODUCT_TEMPLATE_SUCCESS:
            return {
                ...state,
                createTemplate: {
                    loading: false,
                    statusCode: action.payload?.statusCode,
                    statusMessage: action.payload?.statusMessage,
                },
            };
        case MORE_CREATE_PRODUCT_TEMPLATE_FAILURE:
            return {
                ...state,
                createTemplate: {
                    loading: false,
                    statusCode: action.statusCode,
                    statusMessage: action.statusMessage,
                },
            };
        case MORE_RESET_CREATE_TEMPLATE:
            return {
                ...state,
                createTemplate: {
                    loading: false,
                    statusCode: 0,
                    statusMessage: '',
                },
                updateTemplate: {
                    loading: false,
                    statusCode: 0,
                    statusMessage: '',
                },
                orderTemplate: {
                    loading: false,
                    statusCode: 0,
                    statusMessage: '',
                },
                templateDetails: {
                    loading: false,
                    statusCode: 0,
                    statusMessage: '',
                },
            };
            default: {
                return { ...state };
            }
}
};

export default CreateTemplateReducer;
